import { GridColDef } from "@mui/x-data-grid-pro";
import { GKClientDataGrid, GKModal } from "components";
import dayjs from "dayjs";
import { useFetchQuery } from "hooks/useQueries";
import { useParams } from "react-router-dom";
import { GKModalProps } from "utils/commonInterface";
import { extraColumnsField } from "utils/helpers";

interface Props {
  selectedVersion?: {
    date?: string;
    snapshotName?: string;
    snapshotVersion?: number;
  } | null;
}

const Columns: GridColDef[] = [
  {
    ...extraColumnsField("Company Name", "companyName", 120, 1),
    valueGetter: (params) => params?.row?.companyName || "-",
  },
  {
    ...extraColumnsField("ISIN Code", "isinCode", 90, 1),
    valueGetter: (params) => params?.row?.isinCode || "-",
  },
  {
    ...extraColumnsField("Allocation Weightage", "allocation", 160, 1),
    type: "number",
    align: "right",
    headerAlign: "right",
    valueGetter: (params) =>
      params?.row?.allocation ? +params?.row?.allocation : 0,
    valueFormatter: (params) => Number(params?.value)?.toFixed(2),
  },
];

const VersionDetailsModal = ({
  open,
  setOpen,
  selectedVersion,
}: Props & GKModalProps) => {
  const { id } = useParams();

  const { data, isFetching } = useFetchQuery({
    key: [
      "GET_VERSION_WEIGHTAGES_BY_VERSION",
      selectedVersion?.snapshotVersion,
    ],
    route: `model_portfolio/${id}/version/${selectedVersion?.snapshotVersion}/version_weightages/`,
    enabled: Boolean(selectedVersion?.snapshotVersion),
  });

  const items = data?.data?.data?.items || [];

  const modalTitle = selectedVersion?.date
    ? `${selectedVersion?.snapshotName} - ${dayjs(selectedVersion?.date).format(
        "DD MMM YYYY",
      )}`
    : "Version Details";

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={modalTitle}
      maxHeight="90vh"
      loading={isFetching}
    >
      <GKClientDataGrid
        name="versionWeightages"
        density="compact"
        maxHeight={"calc(100vh - 420px)"}
        loading={isFetching}
        showSearch
        columnsButton={false}
        rows={items?.map((item: any, index: number) => ({
          ...item,
          rowId: item?.isinCode || index,
        }))}
        getRowId={(row) => row?.rowId}
        columns={Columns}
        localeText={{ noResultsOverlayLabel: "No Data Found" }}
      />
    </GKModal>
  );
};

export default VersionDetailsModal;
